import axios from "axios";
import HeaderInternal from "./parts/header-internal";
import Footer from "./parts/footer";
import React, {useEffect, useState} from "react";
import ProgramBase from "./program/program-base";

function ProgrammPage() {

    const [post, setPosts] = useState([]);

    const fetchPosts = () => {
        axios
            .get('https://ekonomika.ua/wp-json/wp/v2/events/1963?_fields=acf&acf_format=standard')
            .then((res) => {
                setPosts(res.data.acf);
            });
    }

    useEffect(() => {
        fetchPosts()
    }, [post.data])
    let programData = post.program


    return (
        <>
            <HeaderInternal />
            <section className="py-20">
                <ProgramBase programData={programData} />
            </section>
            <Footer />
        </>
    )
}

export default ProgrammPage;